<template>
  <div class="base-left" v-if="$route.name !== 'OnlineClaim'">
    <div v-if="$route.path.indexOf('userSetting') >= 0" class="userSetting">
      <p>Personal Center</p>
      <p class="last">
        <el-button @click="$router.push({ name: 'WarrantySearch' })"
          >Back to warranty center</el-button
        >
      </p>
    </div>
    <div v-else>
      <p>Aiswei New Energy</p>
      <p class="f16">
        Welcome to the AISWEI product warranty center. Here you can check the
        warranty status of your device, buy extensions of 5,10,15 years and
        activate the extension.
      </p>
      <p class="last">
        Any questions please
        <el-button
          ><a href="https://solplanet.net/contact-us/" target="_blank"
            >Contact us</a
          ></el-button
        >
      </p>
    </div>
  </div>
</template>
<script>
import { setup } from "@/widgets/i18n";
export default {
  computed: {},
  data() {
    return {};
  },
  methods: {
    changeL(lang) {
      this.lang = lang;
      setup(lang);
    },
  },
  created() {},
};
</script>
<style lang="stylus">
.isPC .base-left {
  position: absolute;
  left: 0;
  background: linear-gradient(270deg, #AB499E 0%, #FF4F4F 100%);
  border-radius: 0px 100px 100px 0px;
  width: 36%;
  color: #fff;

  div {
    float: right;
    padding: 50px 50px 75px;
    width: 50%;
    min-width: 430px;
  }

  .userSetting {
    padding: 59px 0;
    text-align: center;

    .last {
      .el-button {
        width: 240px;
      }
    }
  }

  p {
    font-size: 20px;
    margin-bottom: 20px;
    line-height: 100%;
    line-height: 20px;
  }

  .f16 {
    font-size: 16px;
  }

  .last {
    font-size: 16px;

    .el-button {
      width: 120px;
      height: 32px;
      border-radius: 16px;
      border: 1px solid #FFFFFF;
      background: none;
      color: #fff;
      padding: 0;
      margin-left: 20px;

      a {
        color: #fff;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}

.isPhone {
  .w1200 {
    padding: 0;
  }

  .base-left {
    padding: 30px 20px 0;

    p {
      margin-bottom: 30px;
      font-size: 12px;

      &:first-child {
        font-size: 18px;
        font-weight: bold;
      }

      .el-button {
        width: 101px;
        height: 32px;
        border-radius: 16px;
        border: 1px solid #717171;
        background: none;
        color: #717171;
        padding: 0;
        margin-left: 16px;

        a {
          color: #717171;
        }
      }
    }

    .userSetting {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/baseLeft/index.vue